import { Nullable, Program } from '@bybeam/platform-types';
import React, { ReactNode, useContext } from 'react';
import { RouteProps } from 'react-router-dom';
import { CompatRoute, useParams } from 'react-router-dom-v5-compat';
import usePartnerPrograms from './PartnerPrograms/index.js';

export const ProgramContext = React.createContext<string>(undefined);

function ProgramRouteContent({ children }: { children: ReactNode }): JSX.Element {
  const { programId } = useParams<{ programId: string }>();
  return <ProgramContext.Provider value={programId}>{children}</ProgramContext.Provider>;
}

// TODO: component not valid with new react-router v6
export function ProgramRoute({ component: Component, children, ...rest }: RouteProps): JSX.Element {
  return (
    <CompatRoute
      {...rest}
      render={(routeProps): JSX.Element => (
        <ProgramRouteContent>
          {Component ? <Component {...routeProps} /> : children}
        </ProgramRouteContent>
      )}
    />
  );
}

export default function useProgram(): Nullable<Program> {
  const { programs } = usePartnerPrograms();
  const programId = useContext(ProgramContext);
  return programs?.find(({ id }) => id === programId);
}
